import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//import HttpApi from "i18next-http-backend";

import enNav from "./assets/translations/en.nav.json";
import frNav from "./assets/translations/fr.nav.json";
import nlNav from "./assets/translations/nl.nav.json";

import enHome from "./assets/translations/en.home.json";
import frHome from "./assets/translations/fr.home.json";
import nlHome from "./assets/translations/nl.home.json";

import enWhy from "./assets/translations/en.why.json";
import frWhy from "./assets/translations/fr.why.json";
import nlWhy from "./assets/translations/nl.why.json";

const resources = {
  en: {
    translation: enNav,
    home: enHome,
    why: enWhy,
  },
  fr: {
    translation: frNav,
    home: frHome,
    why: frWhy,
  },
  nl: {
    translation: nlNav,
    home: nlHome,
    why: nlWhy,
  },
};

i18n
  .use(LanguageDetector)
  //.use(HttpApi)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["en", "nl", "fr"],
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["cookie", "htmlTag", "localStorage", "path", "subdomain"],
      caches: ["cookie"],
    },

    // backend: {
    //   loadPath: "/assets/translations/{{lng}}.json",
    // },

    //react: { useSuspense: false },
  });

export default i18n;
